// Einheit bearbeiten (objekt_einheiten) – reine Funktionen für das Formular im neuen Design.
// Felder und Zahlenbehandlung wie im früheren Einheiten-Formular (bis Okt. 2026 EinheitFormular.tsx).

import { leseZahl } from './mietverhaeltnisFormular';

export const EINHEIT_TYPEN = ['Wohnung', 'Gewerbe', 'Stellplatz', 'Lager', 'Sonstiges'] as const;
export const WOHNUNGSARTEN = ['Etagenwohnung', 'Erdgeschosswohnung', 'Dachgeschosswohnung', 'Maisonette', 'Penthouse', 'Souterrain', 'Loft', 'Sonstiges'] as const;
export const EINHEIT_STATUS = [
  { key: 'vermietet', label: 'Vermietet' }, { key: 'leerstand', label: 'Leerstand' },
  { key: 'eigennutzung', label: 'Eigennutzung' }, { key: 'renovierung', label: 'Renovierung' },
] as const;

/** Textfelder (alle als Text bearbeitet). */
const TEXT = [
  'bezeichnung', 'typ', 'art_wohnung', 'status', 'etage', 'ausstattung', 'notizen', 'haus_id', 'besitzuebergang',
  'wohnflaeche', 'nutzflaeche', 'zimmer', 'badezimmer', 'schlafzimmer',
  'kaufpreis', 'kaufpreis_stellplatz', 'kaufpreis_garage',
  'nk_makler', 'nk_notar', 'nk_anwalt', 'nk_grunderwerbsteuer', 'nk_eintragung', 'nk_gutachter',
  'finanz_bank', 'finanz_ansprechpartner', 'finanz_darlehenssumme', 'finanz_zinsbindung', 'finanz_zinssatz', 'finanz_tilgung', 'finanz_annuitaet',
  'bank_kontoinhaber', 'bank_iban', 'bank_bic',
] as const;
export type EinheitFeld = typeof TEXT[number];
export type EinheitEntwurf = Record<EinheitFeld, string>;

/** Zahlenfelder wie bisher (NUMERIC_EINHEIT_FIELDS). */
const ZAHLEN: readonly EinheitFeld[] = [
  'wohnflaeche', 'zimmer', 'nutzflaeche', 'badezimmer', 'schlafzimmer',
  'kaufpreis', 'kaufpreis_stellplatz', 'kaufpreis_garage',
  'nk_makler', 'nk_notar', 'nk_anwalt', 'nk_grunderwerbsteuer', 'nk_eintragung', 'nk_gutachter',
  'finanz_darlehenssumme', 'finanz_zinssatz', 'finanz_tilgung', 'finanz_annuitaet',
];
const DATEN: readonly EinheitFeld[] = ['besitzuebergang', 'finanz_zinsbindung'];

const text = (v: unknown): string => (v === null || v === undefined ? '' : typeof v === 'number' ? String(v).replace('.', ',') : String(v));

export function entwurfAusEinheit(e: Record<string, unknown>): EinheitEntwurf {
  const x = {} as EinheitEntwurf;
  for (const f of TEXT) x[f] = DATEN.includes(f) ? text(e[f]).slice(0, 10) : text(e[f]);
  return x;
}

/** Payload für objekt_einheiten.update – Zahlen gelesen, Leeres wird null, Bezeichnung getrimmt. */
export function payloadEinheit(x: EinheitEntwurf): Record<string, unknown> {
  const p: Record<string, unknown> = {};
  for (const f of TEXT) p[f] = x[f].trim() === '' ? null : x[f];
  for (const f of ZAHLEN) p[f] = leseZahl(x[f]);
  p.bezeichnung = x.bezeichnung.trim();
  return p;
}

/** Pflicht: Bezeichnung, eindeutig im Objekt (Groß/Klein egal). */
export function bezeichnungFehler(neu: string, andere: readonly (string | null)[]): string | null {
  const b = neu.trim();
  if (!b) return 'Bitte eine Bezeichnung angeben.';
  if (andere.some(a => (a ?? '').trim().toLowerCase() === b.toLowerCase())) return `„${b}“ gibt es in diesem Objekt schon.`;
  return null;
}
